/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type GroupPolicyEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const groupPolicyEntrypoint: EntryPoint<GroupPolicyEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<GroupPolicyEntrypointComponent>(
			/* webpackChunkName: "async-eoc-group-policy" */ './GroupPolicyPage.tsx',
		),
		getPreloadProps: () => ({}),
	});
